import { ButtonLink } from '../../ButtonLink';
import styles from './styles.module.scss';

type Props = {
  /** 表示するタイトル */
  title: string;
  /** 指定すると右側に「編集」ボタンリンクを表示する */
  editLink?: string;
};

/**
 * 詳細画面で使用するヘッダーコンポーネント
 *
 * タイトルを左側に表示し、editLink が指定された場合は右側に「編集」ボタンリンクを表示する。
 *
 * @param title - 表示するタイトル
 * @param editLink - 編集リンクの URL。指定すると「編集」ボタンリンクを表示する
 */
export const ViewHeader: React.FC<Props> = ({ title, editLink }) => (
  <div className={styles.header}>
    <h2 className={styles.title}>{title}</h2>
    {editLink && (
      <ButtonLink variant='primary' size='md' to={editLink}>
        編集
      </ButtonLink>
    )}
  </div>
);
